<div class="range-input">
  <p [id]="labelId" class="range-input__text-container">
    {{ label }}

    <span aria-hidden="true" class="range-input__text-container__value">
      {{ displayValue || value }}
    </span>
  </p>

  <div class="range-input__rail-container" (click)="onRailClick($event)">
    <div #rail class="range-input__rail-container__rail">
      <div
        class="range-input__rail-container__rail-selected"
        [ngStyle]="{ 'width.%': thumbIndent }"
      ></div>
    </div>

    <div
      #slider
      role="slider"
      [attr.aria-valuemin]="min"
      [attr.aria-valuemax]="max"
      [attr.aria-valuenow]="value"
      [attr.aria-labelledby]="labelId"
      tabindex="0"
      [ngStyle]="{ 'left.%': thumbIndent }"
      (keydown)="onSliderKeyDown($event)"
      (mousedown)="onSliderMouseDown($event)"
      (touchstart)="onSliderMouseDown($event)"
      class="range-input__rail-container__slider"
    ></div>
  </div>
</div>
